import {Container} from "@mantine/core";
import {Result} from "../../result/Result";
import {ThemedPage} from "../ThemedPage/ThemedPage";
import {useTranslation} from "react-i18next";
import {ResizeableContent} from "../../ResizableContent/ResizableContent";
import {useSearchParams} from "react-router-dom";

export type ErrorPageProps = {
  title?: string
  message?: string
}

export const ErrorPage = (props: ErrorPageProps) => {
  const {t} = useTranslation(["common"])

  const [params, _setSearchParams] = useSearchParams();
  const searchParamMessage = params.get("message") ?? undefined;

  const {
    title = t<string>("common.error.oops", "Oops. Something went wrong."),
    message = searchParamMessage
  } = props

  return (
    <ThemedPage>
      {(classes) => (
        <ResizeableContent>
          {(size) => (
            <Container h={size.height} w={size.width} className={classes.container} fluid={true} p="md">
              <Result title={title} message={message}/>
            </Container>
          )}
        </ResizeableContent>
      )}
    </ThemedPage>
  )
}
